
import React, { useState } from 'react';
import { Grid, Card, Typography, TextField, Box, InputAdornment, MenuItem, Autocomplete } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
const FlightDetails = ({
    whatsAppNumber,
    setWhatsAppNumber,
    email,
    setEmail,
    register,
    errors,
    handleSubmit,
    onSubmit,
    setValue
}) => {


    const domains = [
        '@gmail.com',
        '@yahoo.com',
        '@outlook.com',
    ];


    const handleEmailChange = (e, newValue) => {

        setEmail(newValue)
        setValue('email', newValue, { shouldValidate: true })
    }

    return (
        <>
            <Box sx={{ width: '100%', py: 5, px: { xs: 2, md: 4 } }}>
                <Grid container spacing={3} justifyContent="space-between" alignItems="center">
                    <Grid item xs={12} md={8}>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <Box>
                                <Typography variant="body1" fontSize={14}>
                                    Almost done!
                                </Typography>
                                <Typography
                                    variant="body1"
                                    fontSize={14}
                                    sx={{ mt: 2 }}
                                >
                                    Just tell us where we can reach you to send your benefits & more!
                                </Typography>
                                <Grid container spacing={2} sx={{ mt: 2 }}>
                                    <Grid item xs={12} sm={6}>
                                        <Typography sx={{ mb: 1, ml: 0 }} fontWeight="bold">WhatsApp Number  <sup style={{ fontSize: "medium", top: 0, left:3 }} className="text-danger fs-1">*</sup></Typography>
                                        <TextField
                                            fullWidth
                                            InputProps={{
                                                startAdornment: <InputAdornment position="start"><span sx={{fontSize: '12px', marginRight: '5px'}}>+91</span></InputAdornment>,
                                                style: { borderRadius: '20px', backgroundColor: '#e0e4f3', textAlign: 'left' },
                                                ...register('whatsAppNumber'),
                                                inputMode: 'numeric',
                                                pattern: '[0-9]{10}',
                                                maxLength: 10,
                                            }}
                                            sx={{
                                                borderRadius: '20px',
                                                backgroundColor: '#e0e4f3',
                                                '& .MuiOutlinedInput-root': {
                                                    borderRadius: '20px',
                                                    height: '40px',
                                                    // marginLeft: '-10px'
                                                },
                                                '& .MuiInputBase-input': {
                                                    padding: '8px 14px',
                                                    fontSize: '14px',
                                                    // marginLeft: '-20px'
                                                },
                                                '& fieldset': {
                                                    borderWidth: '0.5px',
                                                },
                                            }}
                                            value={whatsAppNumber}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (/^\d{0,10}$/.test(value)) {
                                                    setWhatsAppNumber(value);
                                                    setValue('whatsAppNumber', value, {shouldValidate: true});
                                                }
                                            }}
                                        />
                                        {errors.whatsAppNumber && (
                                            <Typography color="error">
                                                WhatsApp Number is required!
                                            </Typography>
                                        )}
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                    <Typography sx={{ mb: 1 }} fontWeight="bold">Email<sup style={{ fontSize: "medium", top: 0, left:3 }} className="text-danger fs-1">*</sup></Typography>
                                    <Autocomplete
                                        freeSolo
                                        options={
                                        email.length > 2
                                            ? domains.map((domain) => email.split('@')[0] + domain)
                                            : []
                                        }
                                        value={email}
                                        onInputChange={handleEmailChange}
                                        renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            placeholder="Enter your email"
                                            InputProps={{
                                            ...params.InputProps,
                                            style: {
                                                borderRadius: '20px',
                                                backgroundColor: '#e0e4f3',
                                                marginTop: '0px',
                                                padding: '4px 14px',
                                            },
                                            ...register('email'),
                                            }}
                                            sx={{
                                            borderRadius: '20px',
                                            backgroundColor: '#e0e4f3',
                                            '& .MuiOutlinedInput-root': {
                                                borderRadius: '20px',
                                                height: '40px',
                                                padding: '14px 14px',
                                            },
                                            '& .MuiInputBase-input': {
                                                padding: '4px 14px',
                                                fontSize: '14px',
                                                '&::placeholder': {
                                                color: '#000', // dark gray for better visibility
                                                opacity: 1,    // fully opaque
                                                },
                                            },
                                            '& fieldset': {
                                                borderWidth: '0.5px',
                                            },
                                            }}
                                        />
                                        )}
                                    />

                                    {errors.email && (
                                        <Typography color="error">
                                            Email is required!
                                        </Typography>
                                    )}
                                    </Grid>

                                </Grid>
                            </Box>
                        </form>
                    </Grid>

                    <Grid item xs={12} md={4} sx={{ display: 'flex', justifyContent: { xs: 'center', md: 'flex-end' } }}>
                        <Card
                            sx={{
                                backgroundColor: '#fcc000',
                                width: { xs: '202px', sm: '202px' },
                                height: '100px',
                                borderRadius: '15px',
                                display: 'flex',
                                alignItems: 'center'
                            }}
                        >
                            <Box sx={{ textAlign: 'center', width: '100%', p: 1 }}>
                                <Typography variant="body2" fontWeight="bold" fontSize={10}>
                                    We can communicate through
                                </Typography>
                                <Typography variant="h4" fontWeight="bold" fontSize={32} color="#00239c" sx={{ my: 0 }}>
                                    WhatsApp
                                </Typography>
                                <Typography variant="body2" fontWeight="bold" fontSize={10}>
                                    freely when you are travelling
                                </Typography>
                            </Box>
                        </Card>
                    </Grid>
                </Grid>
            </Box>
        </>
    );
}

export default FlightDetails;


